<template>
	<div class="lang-switcher">
		<button
			class="lang-switcher__btn"
			:class="{ active: showLocales }"
			@click="showLocales = !showLocales">
			<span>{{ locale }}</span>
			<Icon name="mdi:chevron-down" size="20" />
		</button>
		<ul v-if="showLocales" class="lang-switcher__list">
			<li
				v-for="(code, i) in availableLocales"
				:key="i"
				class="lang-switcher__item"
				:class="{ active: code === locale }"
				@click="handleChangeLocale(code)">
				{{ code }}
			</li>
		</ul>
	</div>
</template>

<script setup lang="ts">
	import type { LocaleObject } from '@nuxtjs/i18n'

	const { availableLocales, locale, setLocale } = useI18n()

	const showLocales = ref(false)

	const handleChangeLocale = async (code: LocaleObject['code']) => {
		await setLocale(code)
		showLocales.value = false
	}
</script>

<style scoped lang="scss">
	.lang-switcher {
		position: relative;
		color: var(--white);
		&__btn {
			display: flex;
			align-items: center;
			padding: 0 8px;
			color: inherit;
			text-transform: uppercase;
			span {
				margin-right: 8px;
			}
		}
		&__list {
			position: absolute;
			top: 40px;
			right: 0;
			z-index: 10;
			padding: 8px 0;
			background-color: var(--black);
			border-radius: 8px;
			box-shadow: 0 2px 4px rgb(0 0 0 / 20%);
			.lang-switcher__item {
				padding: 8px 16px;
				text-transform: uppercase;
				cursor: pointer;
				&.active {
					color: var(--black);
					background-color: var(--white);
				}
			}
		}
	}
</style>
